import React, { useState, useEffect, useContext } from 'react';
import { Tooltip, IconButton } from '@mui/material';
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import BookmarkAddedIcon from '@mui/icons-material/BookmarkAdded';
import BookmarksContext from '../context/BookmarkContext';
import BookmarkIcon from '@mui/icons-material/Bookmark';

const BookmarkButton = ({ selectedSearchFilter }) => {

  const { bookmarks, addBookmark, removeBookmark, isBookmarked } = useContext(BookmarksContext)

  const handleBookmarkClick = () => {
    if (isBookmarked(selectedSearchFilter)) {
      removeBookmark(selectedSearchFilter);
    } else {
      addBookmark(selectedSearchFilter);
    }
  };

  return (
    <Tooltip title={isBookmarked ? 'Remove Bookmark' : 'Add Bookmark'} arrow>
      <IconButton onClick={handleBookmarkClick}>
        {isBookmarked(selectedSearchFilter) ? <BookmarkIcon  sx={{ color: '#ffc202' }} /> : <BookmarkBorderOutlinedIcon />}
      </IconButton>
    </Tooltip>
  );
};

export default BookmarkButton;